import { asRecord, asString, defaultCrmColumnConfig, parseCrmColumnConfig } from './crm-config';
import type { CrmColumnConfig } from './crm-config';

export type CaspioConfig = CrmColumnConfig & {
  clientId?: string;
  clientSecret?: string;
  accountId?: string;
};

export const defaultCaspioConfig: CaspioConfig = defaultCrmColumnConfig;

export function parseCaspioConfig(value: unknown): CaspioConfig {
  const record = asRecord(value);

  return {
    ...parseCrmColumnConfig(value),
    clientId: asString(record?.clientId),
    clientSecret: asString(record?.clientSecret),
    accountId: asString(record?.accountId),
  };
}

export function isCaspioConfigComplete(config: CaspioConfig) {
  return Boolean(config.tableName && config.customerIdColumn && config.phoneMatchColumn);
}

export function hasCustomCredentials(config: CaspioConfig) {
  return Boolean(config.clientId ?? config.clientSecret ?? config.accountId);
}

export function withCredentialVisibility(config: CaspioConfig, showCredentials: boolean): CaspioConfig {
  if (showCredentials) return config;

  return { ...config, clientId: undefined, clientSecret: undefined, accountId: undefined };
}
